import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'

export async function list (filtros, all = false) {
  return httpAuth.get(`/admin/pessoas?${serialize({ ...filtros, all })}`, { tela: 'acesso_usuario' })
}

export async function get (id) {
  return httpAuth.get(`/admin/pessoas/${id}`, { tela: 'acesso_pessoa' })
}

export async function add (dados) {
  return httpAuth.post('/admin/pessoas', dados, { funcionalidade: 'acesso_pessoa_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/admin/pessoas/${id}`, dados, { funcionalidade: 'acesso_pessoa_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/admin/pessoas/${id}`, { funcionalidade: 'acesso_pessoa_excluir' })
}
